const rankingItems = [
  { rank: 1, title: '迷雾追踪 第二季', type: '悬疑剧集', hot: '本周最热', trend: 'up' },
  { rank: 2, title: '星际之门：起源', type: '科幻电影', hot: '新片上线', trend: 'up' },
  { rank: 3, title: '无声的告白', type: '韩剧', hot: '豆瓣9.1', trend: 'up' },
  { rank: 4, title: '山海经之再见怪兽', type: '国产动画', hot: '全网首发', trend: 'up' },
  { rank: 5, title: '暗夜追踪', type: '犯罪电影', hot: '预告热播', trend: 'new' },
  { rank: 6, title: '长安十二味', type: '纪录片', hot: '口碑推荐', trend: 'up' },
  { rank: 7, title: '时空旅人', type: '科幻剧集', hot: '持续热播', trend: 'stable' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-2">Hot Ranking</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            本周最受欢迎的影视作品 TOP 7
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl border border-background-200/60 bg-background-50 mb-3 last:mb-0 cursor-pointer hover:border-accent-300/40 transition-all duration-200"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold whitespace-nowrap ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">{item.type}</p>
              </div>

              <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                item.trend === 'up'
                  ? 'bg-accent-100 text-accent-700'
                  : item.trend === 'new'
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {item.hot}
              </span>

              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-xs"></i>}
                {item.trend === 'new' && <i className="ri-sparkling-line text-primary-500 text-xs"></i>}
                {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}